import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDatepicker } from '@angular/material/datepicker';
import { ApiService } from 'src/app/shared/services/api.service';
import { ToastrMsgService } from 'src/app/shared/services/shared-services/toastr.service';

@Component({
  selector: 'app-add-closure',
  templateUrl: './add-closure.component.html',
  styleUrl: './add-closure.component.css'
})
export class AddClosureComponent implements OnInit {
  executionFrom !: FormGroup;
  selectedDomain = 'Residential'; // default
  domainOptions:any[] = [];
  // [
  //   'Residential', 'Commercial', 'Educational', 'Water',
  //   'Power', 'Gas', 'Telecom', 'Road', 'Consultancy'
  // ];
  optionsMap: { [key: string]: any[] } = {
    domainOptionsDrp: this.domainOptions
  };

  domainFields: { [key: string]: any[] } = {
    Residential: [
      { "key": "occupancyCertificate", "label": "Occupancy Certificate", "type": "text", "required": true, "value": "Issued" },
      { "key": "handoverDate", "label": "Handover Date", "type": "date", "required": true, "value": "2024-01-25" },
      { "key": "residentOnboardingDocs", "label": "Resident Onboarding Docs", "type": "text", "required": false, "value": "Welcome kit, manuals" }
    ]
    ,
    Commercial: [
      { "key": "leaseAgreementFinalized", "label": "Lease Agreement Finalized", "type": "text", "required": true, "value": "Signed with tenants" },
      { "key": "facilityManagementPlan", "label": "Facility Management Plan", "type": "text", "required": true, "value": "AMC schedule included" },
      { "key": "fireSafetyAuditReport", "label": "Fire Safety Audit Report", "type": "text", "required": true, "value": "Approved by Fire Dept." }
    ]

    ,
    Educational: [
      { "key": "accreditationStatus", "label": "Accreditation Status", "type": "text", "required": true, "value": "Applied to CBSE" },
      { "key": "staffInductionSchedule", "label": "Staff Induction Schedule", "type": "date", "required": true, "value": "2024-02-01" },
      { "key": "studentAdmissionStart", "label": "Student Admission Start", "type": "date", "required": true, "value": "2024-03-01" }
    ]

    ,
    Water: [
      { "key": "waterQualityClearance", "label": "Water Quality Clearance", "type": "text", "required": true, "value": "Approved by Pollution Board" },
      { "key": "operationalSOPs", "label": "Operational SOPs", "type": "text", "required": true, "value": "Daily checks, emergency protocol" },
      { "key": "maintenanceSchedule", "label": "Maintenance Schedule", "type": "text", "required": false, "value": "Quarterly" }
    ]

    ,
    Power: [
      { "key": "gridIntegrationStatus", "label": "Grid Integration Status", "type": "text", "required": true, "value": "Live" },
      { "key": "loadTestingCertificate", "label": "Load Testing Certificate", "type": "text", "required": true, "value": "Passed" },
      { "key": "maintenanceContract", "label": "Maintenance Contract", "type": "text", "required": false, "value": "2-year AMC signed" }
    ]

    ,
    Gas: [
      { "key": "safetyClearance", "label": "Safety Clearance", "type": "text", "required": true, "value": "Approved by Gas Authority" },
      { "key": "userManualDistribution", "label": "User Manual Distribution", "type": "text", "required": false, "value": "Sent to all stakeholders" },
      { "key": "emergencyResponsePlan", "label": "Emergency Response Plan", "type": "text", "required": true, "value": "Finalized and trained" }
    ]

    ,
    Telecom: [
      { "key": "networkActivationDate", "label": "Network Activation Date", "type": "date", "required": true, "value": "2024-01-22" },
      { "key": "slaDocumentation", "label": "SLA Documentation", "type": "text", "required": true, "value": "99.9% uptime commitment" },
      { "key": "customerOnboardingKit", "label": "Customer Onboarding Kit", "type": "text", "required": false, "value": "Setup guide, support info" }
    ]

    ,
    Road: [
      { "key": "roadSafetyAudit", "label": "Road Safety Audit", "type": "text", "required": true, "value": "Approved" },
      { "key": "trafficSignageInstalled", "label": "Traffic Signage Installed", "type": "text", "required": true, "value": "Complete" },
      { "key": "publicAccessDate", "label": "Public Access Date", "type": "date", "required": true, "value": "2024-01-30" }
    ]

    ,
    Consultancy: [
      { "key": "finalAdvisoryReport", "label": "Final Advisory Report", "type": "text", "required": true, "value": "Submitted to client" },
      { "key": "clientFeedbackSummary", "label": "Client Feedback Summary", "type": "text", "required": false, "value": "Positive with suggestions" },
      { "key": "knowledgeTransferDocs", "label": "Knowledge Transfer Docs", "type": "text", "required": false, "value": "Shared via portal" }
    ]


  };


  commonFields = [
    { "key": "projectName", "label": "Project Name", "type": "text", "required": true, "value": "SigmaTConflux Infrastructure Project" },
    { "key": "projectId", "label": "Project ID", "type": "number", "required": true, "value": 12345 },
    { "key": "closureLead", "label": "Closure Lead", "type": "text", "required": true, "value": "Neha Srinivasan" },
    { "key": "closureDate", "label": "Closure Date", "type": "date", "required": true, "value": "2024-01-20" },
    { "key": "finalReportReference", "label": "Final Report Reference", "type": "text", "required": true, "value": "CLSR-2024-001" },
    { "key": "completionCertificate", "label": "Completion Certificate", "type": "text", "required": true, "value": "Issued by Municipal Authority" },
    { "key": "finalBudgetUtilization", "label": "Final Budget Utilization", "type": "currency", "required": true, "value": "₹ 98,000,000" },
    { "key": "lessonsLearnedSummary", "label": "Lessons Learned Summary", "type": "text", "required": false, "value": "Delays due to monsoon, improved safety" },
    { "key": "stakeholderSignoff", "label": "Stakeholder Sign-off", "type": "text", "required": true, "value": "Received from all parties" },
    { "key": "archivalReferenceCode", "label": "Archival Reference Code", "type": "text", "required": false, "value": "ARCH-2024-Infra" },
    { key: 'domain', label: 'Domain', type: 'select', optionKey: 'domainOptionsDrp', required: true, value: 'Residential', onChange: (value: string) => this.onDomainChange(value) }
  ];

  pickerMap: { [key: string]: MatDatepicker<any> } = {};
  constructor(private fb: FormBuilder, private readonly apiService: ApiService, private readonly toastrMsgService: ToastrMsgService) { }

  ngOnInit(): void {
    this.executionFrom = this.fb.group({});
    this.commonFields.forEach(field => {
      const validators = field.required ? [Validators.required] : [];
      this.executionFrom.addControl(field.key, this.fb.control(field.value || '', validators));
    });
    this.onDomainChange(this.selectedDomain);
  }



  onSubmit() {
    if (this.executionFrom.valid) {
      console.log(this.executionFrom.value);
    }
  }
  onReset(): void {
    this.executionFrom.reset();
  }
  onDomainChange(domain: string) {
    this.selectedDomain = domain;
    Object.keys(this.executionFrom.controls).forEach(key => {
      if (key !== 'domain' && this.domainFields[domain]?.find(field => field.key === key) === undefined &&
        Object.values(this.domainFields).flat().some(field => field.key === key)) {
        this.executionFrom.removeControl(key);
      }
    });

    this.domainFields[domain].forEach(field => {
      this.executionFrom.addControl(field.key, this.fb.control(field.value));
    });

  }

}

